export const BUILD_VERSION = '1790887790';
